// Findings #199: a record imported from the daily sheet gets an id built from
// what it is (facility, unit, lot, day, kind), not a random one. Importing the
// same file again, or a corrected copy, updates those records instead of adding
// a second mortality or count. The ids are UUIDs (name-based, version 5 layout)
// because the server only accepts UUIDs.

const NAMESPACE = 'sunday-daily-sheet-v1'

export const nameBasedUuid = async (name: string): Promise<string> => {
  const bytes = new Uint8Array(await crypto.subtle.digest('SHA-1', new TextEncoder().encode(`${NAMESPACE}|${name}`))).slice(0, 16)
  bytes[6] = (bytes[6] & 0x0f) | 0x50
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`
}

export const dailySheetRecordId = (args: { farmId: string; unitId: string; lotId: string; day: string; kind: string }): Promise<string> => (
  nameBasedUuid([args.farmId, args.unitId, args.lotId, args.day, args.kind].join('|'))
)
